const tip = document.querySelector('.tip-card');

const showTip = () => {
  if(!tip) {
    return;
  }
  tip.classList.add('open');
  sessionStorage.setItem('tipShown', 'yes');
}

const tipCloseBtn = tip ? tip.querySelector('.btn-close') : null;

const hideTip = () => {
  if(!tip) {
    return;
  }
  tip.classList.remove('open');
}

if('yes' !== sessionStorage.getItem('tipShown')) {
  setTimeout(showTip, 3000);
}

if(tipCloseBtn) {
  tipCloseBtn.addEventListener('click', hideTip);
}

